import { call, put } from "redux-saga/effects";
import { setActiveRequestsMessages, setOtherMessages, setPartOfferMessages } from "../../entities/messages";
import { requestGetPartOfferMessages, requestGetUserActiveRequestsMessages, requestGetUserOtherMessages, requestSendMessage } from "../requests/messages";


export function* handleGetPartOfferMessages(action) {
    try {
        const response = yield call(requestGetPartOfferMessages, action.payload);
        const { data } = response;
        yield put(setPartOfferMessages({ ...data }));
    } catch (error) {
        console.log(error);
    }
}

export function* handleGetUserActiveRequestsMessages(action) {
    try {
        const response = yield call(requestGetUserActiveRequestsMessages, action.payload);
        const { data } = response;
        yield put(setActiveRequestsMessages({ ...data }));
    } catch (error) {
        console.log(error);
    }
}


export function* handleGetUserOtherMessages(action) {
    try {
        const response = yield call(requestGetUserOtherMessages, action.payload);
        const { data } = response;
        yield put(setOtherMessages({ ...data }));
    } catch (error) {
        console.log(error);
    }
}


export function* handleSendMessage(action) {
    try {
        const response = yield call(requestSendMessage, action.payload);

        if (response.data) {
            const props = { partOfferId: action.payload.part_offer_id };
            const messages = yield call(requestGetPartOfferMessages, props);
            const { data } = messages;

            yield put(setPartOfferMessages({ ...data }));
        };
    } catch (error) {
        console.log(error);
    }
}
